import config from '../config';

const localeConfig = config.locale;


/**
 * @param localeTag {String} Locale tag with region code
 * @returns {String} Two character base locale
 */
export const getBaseLocaleTag = localeTag => {

    return localeTag.split('-')[0];
};


/**
 * @param locale {String} Locale to parse
 * @returns {String} Either lowercase two char locale tag or locale tag with uppercase region code
 */
export const parseLocaleTag = locale => {

    const localeParts = locale.split('-');

    return `${localeParts[0].toLowerCase()}${localeParts[1] ? `-${localeParts[1].toUpperCase()}` : ''}`;
};


/**
 * @returns {String} Detected browser locale or config default
 */
export const detectBrowserLocaleTag = () => {

    const detectedLocaleTag = (navigator.languages && navigator.languages[0])
        || navigator.language
        || navigator.browserLanguage
        || config.locale.defaultLocaleTag;

    const providedLocaleTag = parseLocaleTag(detectedLocaleTag);
    const availableLocaleTags = localeConfig.available.map(({tag}) => tag);

    // provided locale exists, best case scenario
    if (availableLocaleTags.includes(providedLocaleTag)) {

        return providedLocaleTag;
    }

    const providedBaseLocaleTag = getBaseLocaleTag(providedLocaleTag);
    const availableBaseLocale = localeConfig.available.filter(({isBase}) => isBase);

    // matching base locale found latest with default configuration fallback
    for (let i = 0; i < availableBaseLocale.length; i++) {
        const baseLocale = availableBaseLocale[i];
        if (baseLocale.tag.startsWith(providedBaseLocaleTag)) {

            return baseLocale.tag;
        }
    }

    // just to be sure
    return config.locale.defaultLocaleTag;
};


/**
 * Returns the base locale of the browser detected language
 *
 * @return {string} Base locale
 */
export const detectBaseLocale = () => {

    const detectedLocale = detectBrowserLocaleTag();

    return getBaseLocaleTag(detectedLocale);
};
